<script>
    import { Child } from 'pym.js';
    import Graphic from './Graphic.svelte';
    import pkg from '../package.json';
    import meta from './data/meta.json';
    import { onMount } from 'svelte';
    import manageParams from './utils/manageParams.js';
    
    let pymChild = $state();
    let width = $state(600);
    let height = $state(0);  
    let containerElement = $state();
    let manifestData = $state(null);

    const params = manageParams();
    
    const manifestUrl = 'https://ix-cnn-io-prod.s3.amazonaws.com/data/sst-anomaly-snapshots/20260420-pacific-warming/manifest.json';

    const copy = { legend: 'Sea surface temperature anomaly (°F)' };
    
    function handlePymResize(newWidth) {
      width = newWidth;
    }
    
    function sendHeight() {
      if (pymChild) {
        pymChild.sendHeight();
      }
    }
    
    // Fetch manifest data
    fetch(manifestUrl)
      .then(response => response.json())
      .then(data => {
        manifestData = data;
      })
      .catch(error => {
        console.error('Error fetching manifest:', error);
      });
    
    // REACT TO HEIGHT CHANGES using $effect
    $effect(() => {
      if (pymChild && height > 0) {
        sendHeight();
      }
    });

    onMount(() => {
      pymChild = new Child({ 
        renderCallback: handlePymResize, 
        id: pkg.name 
      });

      // Add app class to meta container if app param is true
      if (params.app === 'true') {
        document.querySelector('#meta')?.classList.add('app');
      }
      
      document.querySelector('h1.headline').innerHTML = meta.headline;
      document.querySelector('h2.subhed').innerHTML = meta.subhed;

      if (containerElement) {
        const containerWidth = containerElement.clientWidth;
        if (containerWidth && containerWidth !== width) {
          width = containerWidth;
        }
      }
      
      return () => {
        if (pymChild) {
          pymChild.remove();
        }
      };
    });
  </script>
  
  <!-- BIND HEIGHT HERE -->
  <div bind:this={containerElement} bind:clientHeight={height} bind:clientWidth={width} class="app-container" class:app={params.app === 'true'}>
    <Graphic {width} {manifestData} {copy} {params} />
  </div>
  
  <style>
    .app-container {
      width: 100%;
    }
  </style>
